import { isNotFoundError } from "@mixitone/oom";
import { captureException } from "@mixitone/telemetry";
import { isStaleAssetError, tryRecoverStaleAsset } from "@mixitone/util";
import { useEffect, useLayoutEffect } from "react";
import { useRouteError } from "react-router-dom";
import { useRouteLoadNotFound } from "./RouteLoadNotFoundContext";

export function RouteLoadError() {
  const error = useRouteError();
  const renderNotFound = useRouteLoadNotFound();
  const staleAsset = isStaleAssetError(error);

  useLayoutEffect(() => {
    tryRecoverStaleAsset(error);
  }, [error]);

  useEffect(() => {
    if (staleAsset || isNotFoundError(error)) return;
    captureException(error, { extra: { source: "RouteLoadError" } });
  }, [error, staleAsset]);

  if (staleAsset) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center p-6 text-center text-slate-600">
        Updating…
      </div>
    );
  }

  if (isNotFoundError(error)) {
    if (renderNotFound) {
      return <>{renderNotFound()}</>;
    }
  }

  const details =
    error instanceof Error && error.message
      ? error.message
      : "We hit an unexpected issue while loading this page.";

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-2xl font-semibold">Something went wrong</h1>
      <p className="max-w-xl text-slate-600">{details}</p>
      <button
        type="button"
        className="rounded-md bg-brand-600 px-4 py-2 text-white hover:bg-brand-700"
        onClick={() => window.location.reload()}
      >
        Reload page
      </button>
    </div>
  );
}
